module.exports = __webpack_public_path__ + "img/Foundation-02.f530645c.jpg";